import { render, staticRenderFns } from "./Curve3d.vue?vue&type=template&id=91d4ff08&scoped=true&"
import script from "./Curve3d.vue?vue&type=script&lang=js&"
export * from "./Curve3d.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d4ff08",
  null
  
)

export default component.exports